import React from 'react'
import { Flex, Label, Text } from '@workwhile/ui'
import { CopyableCode } from 'components/Shared/CopyableCode'
import {
  BankAccountPaymentMethod,
  DebitCardPaymentMethod,
  PayoutPaymentMethod,
} from 'api/payments/getUserPayments'
import { toTitleCase } from 'lib/string'

const getBankAccountKindTagLabel = (
  paymentMethod: BankAccountPaymentMethod
): string =>
  paymentMethod.accountType
    ? toTitleCase(paymentMethod.accountType.toLowerCase())
    : 'Bank account'

const DebitCardDestinationDetails = ({
  paymentMethod,
}: {
  paymentMethod: DebitCardPaymentMethod
}) => (
  <Flex alignItems="center" gap={1} flexWrap="wrap" lineHeight="1.4">
    <Text fontSize="sm" as="span">
      ID
    </Text>
    <CopyableCode value={String(paymentMethod.destinationId)} />
    <Label variant="neutral" size="small" as="span">
      Debit card
    </Label>
    {paymentMethod.displayName ? (
      <Text fontSize="sm" as="span">
        Card holder name: {paymentMethod.displayName}
      </Text>
    ) : null}
    {paymentMethod.last4 ? (
      <Text fontSize="sm" as="span">
        •••• {paymentMethod.last4}
      </Text>
    ) : null}
  </Flex>
)

const BankAccountDestinationDetails = ({
  paymentMethod,
}: {
  paymentMethod: BankAccountPaymentMethod
}) => (
  <Flex alignItems="center" gap={1} flexWrap="wrap" lineHeight="1.4">
    <Text fontSize="sm" as="span">
      ID
    </Text>
    <CopyableCode value={String(paymentMethod.destinationId)} />
    <Label variant="neutral" size="small" as="span">
      {getBankAccountKindTagLabel(paymentMethod)}
    </Label>
    {paymentMethod.last4 ? (
      <Text fontSize="sm" as="span">
        •••• {paymentMethod.last4}
      </Text>
    ) : null}
  </Flex>
)

/** Destination details for expanded Highnote payment panels. */
export const PayoutDestinationDetails = ({
  paymentMethod,
}: {
  paymentMethod: PayoutPaymentMethod
}) =>
  paymentMethod.destinationType === 'debit_card' ? (
    <DebitCardDestinationDetails paymentMethod={paymentMethod} />
  ) : (
    <BankAccountDestinationDetails paymentMethod={paymentMethod} />
  )
